import { faEye, faTimes } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { viewRole } from "../../redux/features/roles/rolesSlice";

function ViewRole({ roleId }) {
  const dispatch = useDispatch();
  const { selectedRole, viewRoleLoading } = useSelector((state) => state.roles);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const handleOpen = () => {
    setIsModalOpen(true);
    dispatch(viewRole(roleId));
  };
  const handleClose = () => setIsModalOpen(false);

  return (
    <div>
      <button
        onClick={handleOpen}
        className="text-blue-500 hover:text-blue-700 font-medium"
      >
        <FontAwesomeIcon icon={faEye} />
      </button>

      {isModalOpen && (
        <div className="fixed inset-0 bg-black/60 flex items-center justify-center z-50">
          <div className="bg-white rounded-2xl shadow-lg w-[45%] p-10 relative">
            <button
              onClick={handleClose}
              className="absolute top-4 right-4 text-gray-500 hover:text-gray-700"
            >
              <FontAwesomeIcon icon={faTimes} />
            </button>

            <h2 className="text-xl font-semibold border-b border-gray-200 mb-6 pb-5 text-left">
              View Role
            </h2>

            {viewRoleLoading ? (
              <div className="text-center py-10 text-gray-500 font-medium text-2xl animate-pulse">
                Loading...
              </div>
            ) : (
              <form className="space-y-10">
                <div className="grid grid-cols-1 gap-5">
                  <div>
                    <label className="block text-gray-700 font-medium mb-1 text-left">
                      Name
                    </label>
                    <input
                      type="text"
                      name="name"
                      value={selectedRole?.name}
                      readOnly
                      className="w-full border border-gray-300 rounded-md p-2 bg-gray-100 cursor-not-allowed"
                    />
                  </div>
                  <div>
                    <label className="block text-gray-700 font-medium mb-1 text-left">
                      Permissions
                    </label>
                    <div
                      className="border border-gray-300 rounded-md p-3 h-full max-h-[20vw] overflow-y-auto bg-slate-50"
                      style={{ scrollbarWidth: "none" }}
                    >
                      {selectedRole?.permissions &&
                      selectedRole.permissions.length > 0 ? (
                        <div className="grid grid-cols-1 sm:grid-cols-3 gap-3">
                          {selectedRole.permissions.map((permission) => (
                            <div
                              key={permission.id}
                              className="flex items-center gap-2 p-2 rounded-md bg-white shadow-sm transition"
                            >
                              <span className="text-sm capitalize text-gray-700 ml-5">
                                {permission.name}
                              </span>
                            </div>
                          ))}
                        </div>
                      ) : (
                        <p className="text-gray-400 text-base text-center mt-4">
                          No Permissions Assigned for this Role
                        </p>
                      )}
                    </div>
                  </div>
                </div>

                <div className="flex justify-end gap-3 mt-6">
                  <button
                    type="button"
                    onClick={handleClose}
                    className="px-4 py-2 rounded-md border border-gray-300 hover:bg-gray-100"
                  >
                    Close
                  </button>
                </div>
              </form>
            )}
          </div>
        </div>
      )}
    </div>
  );
}

export default ViewRole;
